/* Shared project list for /projects and home slider */
import kalyanJewellers from '../assets/projects/Kalyan Jewellers.jpg';
import dairyDon from '../assets/projects/Dairy Don.jpg';
import aver from '../assets/projects/Aver.jpg';
import at from '../assets/projects/AT.jpg';
import laSassy from '../assets/projects/La Sassy Looks Salon.jpg';
import prithviPride from '../assets/projects/Prithvi Pride.jpg';
import youngerYou from '../assets/projects/Younger You Face Yoga.jpg';
import kimayra from '../assets/projects/Kimayra.jpg';
import uk14 from '../assets/projects/UK14 Ice Cream.jpg';
import chaiDosti from '../assets/projects/Chai Dosti Amruttulya.jpg';
import project11 from '../assets/projects/Project11.jpg';
import project12 from '../assets/projects/Project12.jpg';
import project13 from '../assets/projects/Project13.jpg';
import project14 from '../assets/projects/Project14.jpg';
import project15 from '../assets/projects/Project15.jpg';
import project16 from '../assets/projects/Project16.jpg';
import project17 from '../assets/projects/Project17.jpg';
import project18 from '../assets/projects/Project18.jpg';
import project19 from '../assets/projects/Project19.jpg';
import project20 from '../assets/projects/Project20.jpg';

export const projectsData = [
  {
    id: 1,
    name: 'Premium ACP sheet work and 3D LED Letter, Signage for Kalyan Jewellers',
    shortDesc:
      'Elegant 3D LED signage with maroon ACP cladding. Durable, bright, and professionally installed for a premium brand look in Goregaon West.',
    imageUrl: kalyanJewellers,
  },
  {
    id: 2,
    name: 'Custom Glow-Sign & 3D LED Branding for Dairy Don',
    shortDesc:
      'Eye-catching 3D LED letters and backlit glow-signs. High-quality finishes designed to boost shop visibility and brand appeal in King Circle.',
    imageUrl: dairyDon,
  },
  {
    id: 3,
    name: 'Professional 3D Acrylic LED Logo Signage for Aver',
    shortDesc:
      'Custom 3D LED acrylic logo with high-impact front lighting. Clean, professional finish designed for corporate branding and exhibitions.',
    imageUrl: aver,
  },
  {
    id: 4,
    name: 'Premium 3D LED Letter Signage for A&T',
    shortDesc:
      'Sleek 3D LED signage with a halo glow effect. High-contrast design for a modern, professional corporate identity.',
    imageUrl: at,
  },
  {
    id: 5,
    name: 'Premium Golden Acrylic 3D Signage for La Sassy Looks Salon',
    shortDesc:
      'Luxurious 3D gold acrylic lettering on a black ACP base. Sleek, professional finish designed to give the salon a premium and stylish look.',
    imageUrl: laSassy,
  },
  {
    id: 6,
    name: 'Architectural Entry Gate Signage for Prithvi Pride',
    shortDesc:
      'Grand 3D entrance gate signage with premium ACP cladding. Durable, weather-resistant, and designed for high-impact residential branding.',
    imageUrl: prithviPride,
  },
  {
    id: 7,
    name: 'Vibrant 3D LED Signage & Glow-Box Logo for Younger You Face Yoga',
    shortDesc:
      'Bright 3D LED letters and backlit logo on black ACP. Eye-catching neon green theme designed for high visibility and a modern feel.',
    imageUrl: youngerYou,
  },
  {
    id: 8,
    name: 'Premium 3D Rose Gold Stainless Steel Backlit Signage for Kimayra',
    shortDesc:
      "Luxury rose gold 3D letters with warm 'halo' backlighting. High-end metallic finish designed for a premium, elegant brand identity.",
    imageUrl: kimayra,
  },
  {
    id: 9,
    name: 'Vibrant 3D LED Glow Signage for UK14 Ice Cream',
    shortDesc:
      'Colorful 3D LED acrylic letters on a purple ACP base. High-visibility design with crisp illumination, perfect for dessert shops and cafes.',
    imageUrl: uk14,
  },
  {
    id: 10,
    name: 'Creative 3D LED Character & Logo Signage for Chai Dosti Amruttulya',
    shortDesc:
      'Custom 3D LED character logo and acrylic lettering. Highly creative, multi-color illuminated signage designed for tea cafes and food brands.',
    imageUrl: chaiDosti,
  },
  {
    id: 11,
    name: 'Modern Corporate Signage for Tech Park',
    shortDesc: 'Contemporary 3D lettering with premium finish for corporate tech park entrance.',
    imageUrl: project11,
  },
  {
    id: 12,
    name: 'Retail Store Front Branding',
    shortDesc: 'Complete storefront makeover with illuminated signage and ACP cladding.',
    imageUrl: project12,
  },
  {
    id: 13,
    name: 'Family Salon Signage Branding',
    shortDesc: 'Professional wayfinding and directional signage for multi-specialty salon.',
    imageUrl: project13,
  },
  {
    id: 14,
    name: 'Building Front Gate Branding',
    shortDesc: 'Complete Building Front Gate branding with 3D letters and informational boards.',
    imageUrl: project14,
  },
  {
    id: 15,
    name: 'Building Name Plate Directory',
    shortDesc: 'Modern Building Name Plate Directory with letters and informational plates.',
    imageUrl: project15,
  },
  {
    id: 16,
    name: 'Builder Sales Office Signage Branding',
    shortDesc: 'Custom  signage creating atmospheric lighting for Builder Sales Office Signage.',
    imageUrl: project16,
  },
  {
    id: 17,
    name: 'Building Terrace Signage',
    shortDesc: 'Building Terrace Signage Branding with Acralic letters and Steel Frame.',
    imageUrl: project17,
  },
  {
    id: 18,
    name: 'OM Sweets and snacks Branding',
    shortDesc: 'OM Sweets and snacks Branding, ACP Sheet Work with LED Box Letters.',
    imageUrl: project18,
  },
  {
    id: 19,
    name: 'Society Intrance Board Branding',
    shortDesc: 'Society Intrance Board Branding with Acralic letters and ACP Sheet Work.',
    imageUrl: project19,
  },
  {
    id: 20,
    name: 'Builder Sales Office Signage Branding',
    shortDesc: 'Builder Sales Office Signage Branding finish for real estate office.',
    imageUrl: project20,
  },
];
